/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc. No part may be reproduced or transmitted in any form by any
 *                 means or for any purpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useState, useEffect, useCallback } from "react";

import { PageLoader } from "@forge/common";

import RbmApplication from "./application/rbm";
import StandaloneApplication from "./application/standalone";
import "./App.scss";

const App = () => {
  const [appType, setAppType] = useState<string>("");

  useEffect(() => {
    // Set the standalone state based on the URL query parameter
    if (window.location.search !== "?name=gatewaymanagement") {
      setAppType("standalone");
    } else {
      setAppType("iframe");
    }
  }, []);

  const renderApp = useCallback(() => {
    if (appType === "standalone") {
      return <StandaloneApplication type={appType} />;
    } else if (appType === "iframe") {
      return <RbmApplication type={appType} />;
    } else {
      return (
        <div>
          <PageLoader isLoading={true} content="Loading" />
        </div>
      );
    }

  }, [appType]);

  return (
    <>
      {renderApp()}      
    </>
  );
};

export default App;